import { useState, useEffect } from 'react'

const useProjectTypes = (props) => {
    const cacheMinutes = 60
    const localStorageKey = 'project_types'
    const localStorageData = localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)) : {}
    const [lastUpdated, setLastUpdated] = useState(localStorageData?.lastUpdated || 0)
    const [ projectTypes, setProjectTypes ] = useState([])
    
    useEffect(() => {
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reload()
    }, [])

    const reload = () => {
        fetch('/v0/project_types', { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setProjectTypes(json.results)
            })
    }

    const getProjectType = (id) => {
        const type = projectTypes?.find(item => item.id === id)
        if( ! type ) {
            return {
                fields: []
            }
        }
        return type
    }
    
    return {
        projectTypes,
        getProjectType,
    }
}

export default useProjectTypes
